// eslint-disable-next-line no-useless-escape
const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

const hasSpecialChars = (val: string): boolean => specialChars.test(val);

export default hasSpecialChars;
